import { SxStyleProp } from 'theme-ui';

export const baseStyle: { [k: string]: SxStyleProp } = {
  mainContainer: {
    padding: ['28px 24px 60px', '60px 0px 90px'],
  },
  heroWithForm: {
    marginBottom: ['40px', '75px'],
  },
  heroWithText: {
    marginBottom: ['60px', '120px'],
  },
  content: {
    margin: ['0 auto 40px', '0 auto 100px'],
    maxWidth: ['950px'],
  },
  contentTitle: {
    color: 'black.100',
    textAlign: 'center',
    marginBottom: ['20px', '75px'],
  },
  contentBody: {
    variant: 'text.bodyIntro',
  },
  middleContent: {
    maxWidth: ['1350px'],
    margin: ['0px auto 70px'],
  },
  sideBySide: {
    marginBottom: ['60px', '92px'],
    '&:last-of-type': {
      marginBottom: ['0px'],
    },
  },
  share: {},
};
